<!-- src/views/pages/finance-accounts/payroll/payroll-overtime.vue -->
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="exportOvertimeCsv">
                    <i class="ti ti-file-type-xls me-1"></i>Export as CSV
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="exportOvertimeExcel">
                    <i class="ti ti-file-spreadsheet me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              class=""
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between my-4">
        <div class="payroll-btns">
          <router-link to="/payroll/payroll" class="btn btn-white border me-2">
            Payments
          </router-link>
          <router-link
            to="/payroll/payroll-overtime"
            class="btn btn-white border me-2"
          >
            Overtime Definitions
          </router-link>
          <router-link
            to="/payroll/payroll-overtime-entries"
            class="btn btn-white border me-2"
          >
            Overtime Entries
          </router-link>
          <router-link
            to="/payroll/payroll-deduction"
            class="btn btn-white border"
          >
            Deductions
          </router-link>
        </div>
        <div class="mb-2">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#add_overtime"
            class="btn btn-primary d-flex align-items-center"
            @click="onAddNew"
            v-can="'Payroll.Create'"
          >
            <i class="ti ti-circle-plus me-2"></i>Add Overtime
          </a>
        </div>
      </div>

      <!-- Policy list -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <div>
            <h5>Overtime Definitions</h5>
            <div class="text-muted fs-13">
              Define reusable overtime rates here. Enter period-specific employee overtime on the
              Overtime Entries page.
            </div>
          </div>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : {{ sortLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'recent'">
                    Recently Added
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'name_asc'">
                    Name A-Z
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'name_desc'">
                    Name Z-A
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'rate_desc'">
                    Highest Rate
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="sortedOvertime"
              :row-selection="rowSelection"
              :loading="loading"
              row-key="id"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'name'">
                  <h6 class="fs-14 fw-medium text-gray-9">
                    {{ record.name }}
                  </h6>
                </template>
                <template v-else-if="column.key === 'rate'">
                  <span>{{ record.rate_type }} {{ record.rate }}x</span>
                </template>
                <template v-else-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#add_overtime"
                      @click="onEdit(record)"
                      v-can="'Payroll.Edit'"
                    >
                      <i class="ti ti-edit"></i>
                    </a>
                    <a href="javascript:void(0);" @click="onDelete(record)" v-can="'Payroll.Delete'">
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /Policy list -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <payroll-overtime-modal ref="overtimeModal" @refresh="fetchAll"></payroll-overtime-modal>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { usePayrollOvertimeStore } from "@/stores/payrollOvertimeStore";
import { exportRowsAsCsv, exportRowsAsExcel } from "@/utils/payrollListExport";

// Static table config
const columns = [
  {
    sorter: false,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Rate",
    dataIndex: "rate",
    key: "rate",
    sorter: (a, b) => (a.rate || 0) - (b.rate || 0),
  },
  {
    title: "",
    key: "action",
    sorter: false,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

// Page text
const title = ref("Payroll Components");
const text = ref("Payroll Company Settings");
const text1 = ref("Overtime Definitions");
const sortOption = ref("recent");

// Modal ref
const overtimeModal = ref(null);

// Store
const overtimeStore = usePayrollOvertimeStore();
const { overtimeList, loading } = storeToRefs(overtimeStore);
const { fetchAll } = overtimeStore;

const sortLabel = computed(() => {
  switch (sortOption.value) {
    case "name_asc":
      return "Name A-Z";
    case "name_desc":
      return "Name Z-A";
    case "rate_desc":
      return "Highest Rate";
    default:
      return "Recently Added";
  }
});

const sortedOvertime = computed(() => {
  const list = Array.isArray(overtimeList.value) ? [...overtimeList.value] : [];

  switch (sortOption.value) {
    case "name_asc":
      return list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    case "name_desc":
      return list.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
    case "rate_desc":
      return list.sort((a, b) => Number(b.rate || 0) - Number(a.rate || 0));
    default:
      return list.sort(
        (a, b) =>
          new Date(b.created_at || 0).getTime() -
          new Date(a.created_at || 0).getTime(),
      );
  }
});

// Lifecycle
onMounted(() => {
  fetchAll();
});

// Methods
const toggleHeader = () => {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
};

const onAddNew = () => {
  overtimeModal.value?.resetForm();
};

const onEdit = (record) => {
  overtimeModal.value?.openForEdit(record);
};

const onDelete = async (record) => {
  overtimeModal.value?.openForDelete(record);
};

const exportOvertimeCsv = () => {
  exportRowsAsCsv(
    "payroll-overtime.csv",
    ["Name", "Rate Type", "Rate Multiplier"],
    sortedOvertime.value.map((item) => [
      item.name,
      item.rate_type || "-",
      item.rate ?? 0,
    ]),
  );
};

const exportOvertimeExcel = () => {
  exportRowsAsExcel(
    "payroll-overtime.xls",
    ["Name", "Rate Type", "Rate Multiplier"],
    sortedOvertime.value.map((item) => [
      item.name,
      item.rate_type || "-",
      item.rate ?? 0,
    ]),
  );
};
</script>


